import { ChangeEvent, FC, useCallback } from 'react';

import {
  Checkbox,
  Skeleton,
} from '@beeline/design-system-react/extracted-styles';

import { CheckboxGroup } from '../CheckboxGroup/CheckboxGroup';

import classes from './RoomAttribute.module.scss';

export interface RoomAttributesProps {
  withTv: boolean;
  onChangeWithTv: (checked: boolean) => void;
  withVideoCalls: boolean;
  onChangeWithVideoCalls: (checked: boolean) => void;
  withFlipChart: boolean;
  onChangeWithFlipChart: (checked: boolean) => void;
  withWater: boolean;
  onChangeWithWater: (checked: boolean) => void;
  loading?: boolean;
}

export const RoomAttributes: FC<RoomAttributesProps> = ({
  withTv,
  onChangeWithTv,
  withVideoCalls,
  onChangeWithVideoCalls,
  withFlipChart,
  onChangeWithFlipChart,
  withWater,
  onChangeWithWater,
  loading,
}) => {
  const changeWithTv = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      onChangeWithTv(e.target.checked);
    },
    [onChangeWithTv],
  );

  const changeWithVideoCalls = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      onChangeWithVideoCalls(e.target.checked);
    },
    [onChangeWithVideoCalls],
  );

  const changeWithFlipChart = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      onChangeWithFlipChart(e.target.checked);
    },
    [onChangeWithFlipChart],
  );

  const changeWithWater = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      onChangeWithWater(e.target.checked);
    },
    [onChangeWithWater],
  );

  return (
    <CheckboxGroup>
      {loading ? (
        <Skeleton className={classes.skeleton} />
      ) : (
        <Checkbox
          label='ТВ'
          checked={withTv}
          onChange={changeWithTv}
          dataTestId='roomWithTv'
        />
      )}
      {loading ? (
        <Skeleton className={classes.skeleton} />
      ) : (
        <Checkbox
          label='Видеоконференцсвязь'
          checked={withVideoCalls}
          onChange={changeWithVideoCalls}
          dataTestId='roomWithVideoCalls'
        />
      )}
      {loading ? (
        <Skeleton className={classes.skeleton} />
      ) : (
        <Checkbox
          label='Флип-чарт'
          checked={withFlipChart}
          onChange={changeWithFlipChart}
          dataTestId='roomWithFlipChart'
        />
      )}
      {loading ? (
        <Skeleton className={classes.skeleton} />
      ) : (
        <Checkbox
          label='Кулер / бутилированная вода'
          checked={withWater}
          onChange={changeWithWater}
          dataTestId='roomWithWater'
        />
      )}
    </CheckboxGroup>
  );
};
